module.exports = __webpack_public_path__ + "static/media/fruits_28.668f950e.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_28.csv
// module id = 693
// module chunks = 0